import domReady from '@wordpress/dom-ready';

domReady( () => {
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  /* Block scripts */
  if ( document.querySelector('.accordion-inner') ) {
    document.querySelectorAll('.accordion-inner').forEach(block => {
      const toggle = block.querySelector('.accordion-inner__title button');
      const title = block.querySelector('.accordion-inner__title');
      const content = block.querySelector('.accordion-inner__content');
      let expanded = toggle.getAttribute('aria-expanded') === 'true' ? true : false;

      if ( !expanded ) {
        content.style.display = 'none';
        gsap.set(content, {
          height: 0,
          paddingTop: 0,
          paddingBottom: 0,
          overflow: 'clip'
        });
      }

      toggle.addEventListener('click', function() {
        
        if ( expanded ) {
          expanded = !expanded;
          
          title.classList.remove('expanded');
          content.style.overflow = 'clip';

          gsap.to(content, {
            height: 0,
            paddingTop: 0,
            paddingBottom: 0,
            overwrite: true,
            duration: 0.5,
            ease: 'power3.inOut',
            onComplete: () => {
              content.style.display = 'none';
            }
          });
        } else {
          expanded = !expanded;
          title.classList.add('expanded');

          gsap.set(content, {
            'clearProps': 'all'
          });
          const paddingTop = parseFloat(getComputedStyle(content).paddingTop);
          const paddingBottom = parseFloat(getComputedStyle(content).paddingBottom);
          const height = content.scrollHeight;

          content.style.display = 'block';
          content.style.overflow = 'clip';
          
          gsap.fromTo(content, {
            height: 0,
            paddingBottom: 0,
            paddingTop: 0
          }, {
            height: height,
            overwrite: true,
            paddingTop: paddingTop,
            paddingBottom: paddingBottom,
            duration: 0.5,
            ease: 'power3.inOut',
            onComplete: () => {
              content.style.overflow = 'visible';
              gsap.set(content, {
                'clearProps': 'all'
              });
            }
          });
        }

        toggle.setAttribute('aria-expanded', expanded ? 'true': 'false');
      });
    });
  }
});

